module.exports = global["rpBreakpoints"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ./~/rp-mq-breakpoints/lib/index.js-exposed
// module id = 46
// module chunks = 1